<!-- SLOT `header`: use a container element. Slot provides `toggleAccordion`, `isOpen`, and `disabled` slot props. Call toggleAccordion to toggle, use isOpen to conditionally style, disabled to show disabled state.
SLOT `content`: use a container element. -->
<template>
  <component
    :is="tag"
    class="flex flex-col"
    data-traverse-component="AppAccordion"
    :aria-disabled="disabled"
  >
    <slot
      name="header"
      :toggle-accordion="toggleAccordion"
      :is-open="isOpen"
      :disabled="disabled"
    />

    <div
      class="grid ease-in-out"
      :class="{
        'grid-rows-[1fr]': isOpen,
        'grid-rows-[0fr]': !isOpen,
        'transition-[grid] duration-500': animate,
      }"
    >
      <div class="overflow-hidden w-full">
        <slot
          name="content"
          :toggle-accordion="toggleAccordion"
          :is-open="isOpen"
          :disabled="disabled"
        />
      </div>
    </div>

    <slot
      name="footer"
      :toggle-accordion="toggleAccordion"
      :is-open="isOpen"
      :disabled="disabled"
    />
  </component>
</template>

<script setup lang="ts">
const props = defineProps({
  defaultClosed: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  tag: {
    type: String,
    default: 'div',
  },
  animate: {
    type: Boolean,
    default: true,
  },
})

const isOpen = ref(!props.defaultClosed)

function toggleAccordion() {
  if (props.disabled) return
  isOpen.value = !isOpen.value
}

defineExpose({
  toggleAccordion,
  isOpen,
})
</script>

<style scoped>
[aria-disabled='true'] {
  pointer-events: none;
}
</style>
